import { useOnline } from "@/contexts/OnlineContext";
import { CloudOff, RefreshCcw, CloudUpload, CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function OfflineBanner() {
  const { online, pending, syncing, syncNow } = useOnline();

  if (online && pending === 0) return null;

  if (!online) {
    return (
      <div
        className="no-print bg-amber-100 border-b border-amber-300 text-amber-900 px-4 py-2 text-sm flex items-center justify-between gap-2"
        data-testid="offline-banner"
      >
        <div className="flex items-center gap-2 flex-1 min-w-0">
          <CloudOff className="h-4 w-4 shrink-0" />
          <span>
            <b>Offline.</b> Puoi continuare a compilare i rapportini, verranno
            sincronizzati appena torni online.
            {pending > 0 && (
              <span className="ml-1">
                ({pending} {pending === 1 ? "modifica" : "modifiche"} in coda)
              </span>
            )}
          </span>
        </div>
      </div>
    );
  }

  // Online but with pending queue
  return (
    <div
      className="no-print bg-blue-50 border-b border-blue-200 text-blue-900 px-4 py-2 text-sm flex items-center justify-between gap-2"
      data-testid="sync-banner"
    >
      <div className="flex items-center gap-2 flex-1 min-w-0">
        {syncing ? (
          <RefreshCcw className="h-4 w-4 shrink-0 animate-spin" />
        ) : (
          <CloudUpload className="h-4 w-4 shrink-0" />
        )}
        <span>
          {syncing
            ? `Sincronizzazione di ${pending} ${
                pending === 1 ? "modifica" : "modifiche"
              } in corso…`
            : `${pending} ${
                pending === 1 ? "modifica" : "modifiche"
              } in attesa di sincronizzazione.`}
        </span>
      </div>
      {!syncing && (
        <Button
          size="sm"
          variant="outline"
          onClick={syncNow}
          className="h-8 text-xs"
          data-testid="sync-now-button"
        >
          <RefreshCcw className="h-3 w-3 mr-1" /> Sincronizza ora
        </Button>
      )}
    </div>
  );
}

export function OnlineIndicator({ className = "" }) {
  const { online } = useOnline();
  if (online) return null;
  return (
    <span
      className={`inline-flex items-center gap-1 text-xs font-bold uppercase tracking-wide text-amber-700 ${className}`}
      data-testid="online-indicator-offline"
    >
      <CloudOff className="h-3 w-3" /> Offline
    </span>
  );
}
